import { motion, useAnimation } from "framer-motion";
import React, { useEffect } from "react";
import { useInView } from "react-intersection-observer";

const HorizontalLine = ({ section }) => {
  const { ref, inView } = useInView({ threshold: 0.1 });
  const line = useAnimation();
  const sectionAnimation = useAnimation();

  useEffect(() => {
    if (inView) {

      line.start({
        width: "40%",
        transition: {
          duration: 1,
          delay: 1,
        }
      });

      sectionAnimation.start({
        y: 0,
        opacity: 1,
        transition:{
          duration: .5,
          delay: 0.1,
          ease:"easeInOut"
        }
      })
    } else {
      line.start({
        width: 0,
        
      });

      sectionAnimation.start({
        y: 80,
        opacity: 0,
      })
    }
  }, [inView]);
  return (
    <div>
      <div className="flex justify-center items-center space-x-2 lg:space-x-5 ">
        <motion.hr
          ref={ref}
          animate={line}
          className="w-[40%] h-0 border-t-[1px] border-blue-700 	box-shadow: 0 0 5px 5px olive"
        />
        <motion.h1
          animate={sectionAnimation}
          ref={ref}
          className="text-blue-600 text-md lg:text-4xl border-2 px-5 lg:px-6 py-1 lg:py-2 border-blue-900  rounded-full ">
          {section}
        </motion.h1>
        <motion.hr
          animate={line}
          ref={ref}
          className="w-[40%] h-0 border-t-[1px] border-blue-700 shadow-2xl shadow-blue-500" />
      </div>
    </div>
  );
};

export default HorizontalLine;
